class PathParameterDto {
    ParameterName: string;
    FieldType: number;
    ValueString: string | null;
    ValueInt32: number | null;
    ValueBoolean: boolean | null;
    ValueDate: string | null;
    ValueDateTime: string | null;
    ValueDateTimeOffset: string | null;

    constructor(parameterName: string, fieldType: number, valueString: string | null = null, valueInt32: number | null = null, valueBoolean: boolean | null = null, valueDate: string | null = null, valueDateTime: string | null = null, valueDateTimeOffset: string | null = null) {
        this.ParameterName = parameterName;
        this.FieldType = fieldType;
        this.ValueString = valueString;
        this.ValueInt32 = valueInt32;
        this.ValueBoolean = valueBoolean;
        this.ValueDate = valueDate;
        this.ValueDateTime = valueDateTime;
        this.ValueDateTimeOffset = valueDateTimeOffset;
    }
}

export default PathParameterDto;
